import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/app/auth/forgot-password/page.tsx");
